import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-ct37',
  templateUrl: './ct37.component.html',
  styleUrls: ['./ct37.component.less']
})
export class Ct37Component implements OnInit, AfterViewInit  {

  @Output() scannerEvent = new EventEmitter<string>();

  constructor() { }

  // le champ scanner est visible ou non pour saisie manuelle
  scannerVisible = false;

  scannerType: string;
  @ViewChild('scannerInput', { static: false }) scannerInput!: ElementRef<HTMLInputElement>;
// start scanner auto variables
  buffer: string ;
  // code scanné ou saisi manuellement
  scannedCode = '';
  manualCode = '';

  private timer: any ;

  ngOnInit(): void {
  }
  ngAfterViewInit(): void {
    // this.scannerInput?.nativeElement.focus();
    this.focusScanner();
  }
  focusScanner(): void {
    setTimeout(() => {
      this.scannerInput?.nativeElement.focus();
    }, 0);
  }
  // bascule entre affichage manuel ou scanner
  toggleScannerInput(): void {
    this.scannerVisible = !this.scannerVisible;
/*
    setTimeout(() => {
      this.scannerInput?.nativeElement.focus();
      if (this.scannerVisible) {
        this.scannerInput.nativeElement.select();
      }
    }, 0);
*/
    setTimeout(() => {
      const el = this.scannerInput.nativeElement;
      el.focus();
      el.select();
    }, 0);
  }
  onInputScanner(event: any): void {
    const val = event.target.value;
 // si l'utilisateur tape manuellement, ne pas vider
    if (this.scannerVisible) {
      return;
    }
    // récupère la valeur complète de l'input (dernière frappe incluse)
    this.buffer = val;
    console.log('Buffer actuel: ', this.buffer);

    // reset du timer
    if (this.timer) {
      clearTimeout(this.timer);
    }

    // fin du scan si plus aucun caractère pendant 60 ms
    this.timer = setTimeout(() => {
      this.finishScan();
    }, 60);

  }
  /*
  onKeydownScanner(event: any): void {
    const val = event.target.value;
    console.log('onKeydown : ', val);
  }
  onKeyupScanner(event: any): void {
    const val = event.target.value;
    console.log('onKeyup : ', val);
  }
    */
  finishManualInput(): void {

    if (!this.scannerVisible) {
      return;
    }
    const inputValue = this.scannerInput.nativeElement.value.trim();
    if (!inputValue) {
      return; // rien à valider
    }
    this.buffer = inputValue;

    if (!this.buffer) {
      return;
    }
    this.scannedCode = this.buffer.trim();
    this.scannerEvent.emit(this.scannedCode);

    this.buffer = '';
    this.scannerVisible = false;  // on cache l'input
    this.resetScanner();           // focus et input vide
  }
  private finishScan(): void {
    if (!this.buffer) { return; }

    this.scannedCode = this.buffer.trim();
    console.log('SCAN TERMINÉ: ', this.scannedCode);
    this.scannerEvent.emit(this.scannedCode);
    // reset
    this.buffer = '';
    this.resetScanner();
  }
  // reset scanner : vider input et focus
  private resetScanner(): void {
    if (this.scannerInput?.nativeElement) {
      this.scannerInput.nativeElement.value = '';
    }
    this.focusScanner();

    // si l'utilisateur était en saisie manuelle, re-cacher
    if (this.scannerVisible) {
      this.scannerVisible = false;
    }
  }
  /*
  @HostListener('document:keydown', ['$event'])
  handleKeydown(event: KeyboardEvent): void {

    // Fin du scan (CR / Enter)
    if (event.key === 'Enter') {
      if (!this.buffer) {
        this.forceFocus();
        return;
      }

      this.scannedCode = this.buffer;
      this.scannerEvent.emit(this.buffer);

      // reset
      this.buffer = '';
      this.forceFocus();
      return;
    }

    // Ignorer touches de contrôle
    if (event.key.length !== 1) {
      return;
    }

    // Accumulation caractères scanner
    this.buffer += event.key;
  }

    */
}

